import React from 'react';
import { CondensedLabel, Layout, ListItem } from '@axiom/ui';

import { ChatCopyButton } from '../ChatCopyButton/ChatCopyButton';

export type ChatEmailFieldProps = {
  contentRef: React.RefObject<HTMLDivElement>;
  suffix: string;
  label: string;
  name: string;
  value: string;
};

export const ChatEmailField = ({
  contentRef,
  suffix,
  label,
  name,
  value,
}: ChatEmailFieldProps) => {
  return (
    <ListItem>
      <Layout position="space-between middle">
        <Layout horizontalGutter="8px" inline position="middle">
          <CondensedLabel>{label}</CondensedLabel>
          <div data-test={`CHAT_EMAIL_${name}_${suffix}`} ref={contentRef}>
            {value}
          </div>
        </Layout>
        <ChatCopyButton
          contentRef={contentRef}
          label={`Copy ${label.toLowerCase()}`}
          markdown={value}
          name={`COPY_EMAIL_${name}_${suffix}`}
        />
      </Layout>
    </ListItem>
  );
};
